import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import OcomPlugin from './vue-ocom/plugin'
//Router that merges all routes in app
import router from './router'

//Use Plugins
import './vue-ocom/plugins'

//Main Store
import store from './store'

//Integrate Ocom Global App
Vue.use(OcomPlugin);

//Config
Vue.config.productionTip = false;

//Vue
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');